import { render, staticRenderFns } from "./Affidavit.vue?vue&type=template&id=0016c9e8"
import script from "./Affidavit.vue?vue&type=script&lang=js"
export * from "./Affidavit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports